import { useIsCurrentPageLiveRaw } from './LivePagesStore.ts';
import { useLivePageSSRStatus } from './useLivePageSSRStatus.ts';

/**
 * Returns if the current page is of subtype `live`. We trust that BE only returns `live` subtype only if the feature is enabled.
 * @returns { boolean } if the current page is of subtype `live`
 */
export const useIsCurrentPageLive = (): boolean => {
	const [isLiveClientside] = useIsCurrentPageLiveRaw();
	const { isTypeKnown: isSSRKnown, isLive: isLiveSSR } = useLivePageSSRStatus();

	// Use SSR value if we know we're in SSR mode, otherwise fall back to client-side store value
	return isSSRKnown ? !!isLiveSSR : isLiveClientside;
};
